import {Breadcrumbs, Link, Typography} from '@mui/material';
import React from 'react';
import AurIcon, {IconColors, IconNames} from '../common/aur-icon/AurIcon';
import {t} from 'i18next';
export interface ChildComponentProps {
  breadCrumArray: {key: string; value: string}[];
  title: string;
  handlePopup: (key: string) => void;
}

const IndexBreadCrumbs: React.FC<ChildComponentProps> = ({
  breadCrumArray,
  title,
  handlePopup,
}) => {
  return (
    <div className="index-breadcrums">
      <Breadcrumbs
        separator={
          <AurIcon
            icon={IconNames.ChevronRight}
            color={IconColors.Secondary}
            size="small"
          />
        }
        aria-label={t('common.breadcrumb')}
        role="navigation"
      >
        {breadCrumArray.map((item) => (
          <div key={item.key}>
            <Link
              tabIndex={0}
              key={item.key}
              onClick={() => handlePopup(item.key)}
              color="inherit"
              underline="hover"
              sx={{
                '&:hover': {
                  color: '#89A6FF',
                  textDecoration: 'underline',
                  textDecorationThickness: '2px',
                  textDecorationColor: '#89A6FF',
                  textUnderlineOffset: '5px',
                  cursor: 'pointer',
                },
              }}
            >
              <Typography
                sx={{color: '#89A6FF'}}
                className="typo-text buttonSmall_size button-text"
              >
                {item.value}
              </Typography>
            </Link>
          </div>
        ))}
        <Typography
          sx={{color: '#C9D1DC'}}
          className="typo-text buttonSmall_size button-text"
        >
          {title}
        </Typography>
      </Breadcrumbs>
    </div>
  );
};

export default IndexBreadCrumbs;
